import "../../config/globalConstants.js";
import { CopyButton as e } from "../CopyButton/CopyButton.js";
import t from "./SnippetWithControls.module.js";
import { c as n } from "react/compiler-runtime";
import r from "classnames";
import { useState as i } from "react";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
import ee from "@jetbrains/icons/eye";
import c from "@jetbrains/icons/eye-crossed";
import { Button as l } from "@jetbrains/ring-ui-built/components/button/button";
import u from "@jetbrains/ring-ui-built/components/code/code";
import d from "@jetbrains/ring-ui-built/components/tooltip/tooltip";
//#region src/components/SnippetWithControls/SnippetWithControls.tsx
var f = (f) => {
	let p = n(43), { code: m, language: h, codeWithHiddenElements: g, hiddenPartName: _, copyButtonTestAttribute: v, multiline: y, horizontalScroll: b, className: x, onCopy: S, onRevealToggle: C, copySuccessText: w, showControls: T, renderControls: E, secondary: D, size: O, "data-test": k } = f, A = h === void 0 ? "bash" : h, j = _ === void 0 ? "" : _, M = y === void 0 || y, N = b !== void 0 && b, P = T === void 0 || T, F = D === void 0 || D, I = O === void 0 ? "normal" : O, L = P && g !== void 0, [R, z] = i(!0), B;
	p[0] !== R || p[1] !== C ? (B = () => {
		let e = !R;
		z(e), C?.(!e);
	}, p[0] = R, p[1] = C, p[2] = B) : B = p[2];
	let V = B, H = g !== void 0 && R ? g : m, U;
	p[3] !== m || p[4] !== v || p[5] !== w || p[6] !== V || p[7] !== j || p[8] !== R || p[9] !== S || p[10] !== P || p[11] !== L ? (U = P ? /* @__PURE__ */ s(a, { children: [L && /* @__PURE__ */ o(d, {
		delay: 800,
		title: `${R ? "Show" : "Hide"} ${j}`.trim(),
		children: /* @__PURE__ */ o(l, {
			"aria-label": `${R ? "Show" : "Hide"} button`,
			"data-test": "eye-button",
			icon: R ? ee : c,
			onClick: V
		})
	}), /* @__PURE__ */ o(e, {
		alertSuccessText: w,
		"data-test": v,
		textToCopy: m,
		onCopy: S
	})] }) : null, p[3] = m, p[4] = v, p[5] = w, p[6] = V, p[7] = j, p[8] = R, p[9] = S, p[10] = P, p[11] = L, p[12] = U) : U = p[12];
	let W = U, G;
	p[13] !== W || p[14] !== E ? (G = E ? E(W) : W, p[13] = W, p[14] = E, p[15] = G) : G = p[15];
	let K = G, q;
	p[16] === K ? q = p[17] : (q = K ? /* @__PURE__ */ o("div", {
		className: t.controls,
		children: K
	}) : null, p[16] = K, p[17] = q);
	let J = q;
	if (!M) {
		let e = t[I], n;
		p[18] !== x || p[19] !== F || p[20] !== e ? (n = r(t.singleLine, e, x, { [t.secondary]: F }), p[18] = x, p[19] = F, p[20] = e, p[21] = n) : n = p[21];
		let i;
		p[22] !== H || p[23] !== A ? (i = /* @__PURE__ */ o("div", {
			className: t.singleLineValue,
			children: /* @__PURE__ */ o(u, {
				language: A,
				code: H
			})
		}), p[22] = H, p[23] = A, p[24] = i) : i = p[24];
		let a;
		return p[25] !== J || p[26] !== k || p[27] !== n || p[28] !== i ? (a = /* @__PURE__ */ s("div", {
			role: "group",
			"aria-label": "Code snippet",
			"data-test": k,
			className: n,
			children: [i, J]
		}), p[25] = J, p[26] = k, p[27] = n, p[28] = i, p[29] = a) : a = p[29], a;
	}
	let Y;
	p[30] === x ? Y = p[31] : (Y = r(t.multiLineContainer, x), p[30] = x, p[31] = Y);
	let X = !N, Z;
	p[32] === X ? Z = p[33] : (Z = r(t.multiLine, { [t.noScroll]: X }), p[32] = X, p[33] = Z);
	let Q;
	p[34] !== H || p[35] !== A || p[36] !== Z ? (Q = /* @__PURE__ */ o(u, {
		className: Z,
		language: A,
		code: H
	}), p[34] = H, p[35] = A, p[36] = Z, p[37] = Q) : Q = p[37];
	let $;
	return p[38] !== J || p[39] !== k || p[40] !== Y || p[41] !== Q ? ($ = /* @__PURE__ */ s("div", {
		role: "group",
		"aria-label": "Code snippet",
		"data-test": k,
		className: Y,
		children: [Q, J]
	}), p[38] = J, p[39] = k, p[40] = Y, p[41] = Q, p[42] = $) : $ = p[42], $;
};
//#endregion
export { f as SnippetWithControls };
